import { useEffect } from "react"
import { useLocation } from "react-router-dom"
import { applySeoMeta, getSeoLanguage } from "../../utils/seoMeta"

export default function SeoMeta() {
  const { pathname } = useLocation()

  useEffect(() => {
    applySeoMeta(getSeoLanguage(pathname), pathname)
  }, [pathname])

  return null
}
